/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { getCashFlowPreselectedFilters, getCoinsRequest, getCompaniesRequest, setCashFlowPreselectedFilters} from "../../actions/cash-flow.action"
import { useDispatch, useSelector } from "react-redux"
import ProjectsSearchInput from "./ProjectsSearchInput"
import { Grid } from "@material-ui/core"
import MaterialSelect from "../../components/MaterialSelect"
import MaterialDateInput from "../../components/MaterialDateInput"

const Modes = [{
  value: '-1',
  label: 'Proyectos',
}, {
  value: '1',
  label: 'Dimensión 1',
}, {
  value: '2',
  label: 'Dimensión 2',
}, {
  value: '3',
  label: 'Dimensión 3',
}, {
  value: '4',
  label: 'Dimensión 4',
}, {
  value: '5',
  label: 'Dimensión 5',
}]

const Periods = [{
  value: '0',
  label: 'Mensual'
}, {
  value: '1',
  label: 'Semanal'
}, {
  value: '2',
  label: 'Anual'
}]


const InputsGroup = ({
  selectedCoin,
  setSelectedCoin,
  selectedCompany,
  setSelectedCompany,
  mode,
  setMode,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  period,
  setPeriod,
  selectedProject,
  setSelectedProject,
}) => {
  const cashFlow = useSelector((state) => state.cashFlow);
  const dispatch = useDispatch();
  const [filterHasChanged, setFilterHasChanged] = useState(false)
  const [filterFirstCharge, setFilterFirstCharge] = useState(true)

  useEffect(() => {
    if (cashFlow.userFilters) {
      return;
    }
    dispatch(getCashFlowPreselectedFilters())
  }, [])

  useEffect(() => {
    if (!filterHasChanged) {
      return
    }
    dispatch(setCashFlowPreselectedFilters(selectedCoin, selectedCompany, mode, selectedProject, period, startDate, endDate))
  }, [selectedCoin, selectedCompany, mode, startDate, endDate, period, selectedProject])

  useEffect(() => {
    if (!cashFlow.userFilters || !filterFirstCharge) {
      return;
    }
    if (cashFlow.userFilters?.Modo) {
      setMode(cashFlow.userFilters?.Modo)
    }
    if (cashFlow.userFilters?.Moneda) {
      setSelectedCoin(cashFlow.userFilters?.Moneda)
    }
    if (cashFlow.userFilters?.Del && cashFlow.userFilters?.Del.includes('T')) {
      const newDate = cashFlow.userFilters?.Del.split('T')[0].split('-')
      setStartDate(`${newDate[2]}/${newDate[1]}/${newDate[0]}`)
    } else if (cashFlow.userFilters?.Del) {
      setStartDate(cashFlow.userFilters?.Del)
    } else {
      setStartDate(`01/01/${new Date().getFullYear()}`)
    }
    if (cashFlow.userFilters?.Al && cashFlow.userFilters?.Al.includes('T')) {
      const newDate = cashFlow.userFilters?.Al.split('T')[0].split('-')
      setEndDate(`${newDate[2]}/${newDate[1]}/${newDate[0]}`)
    } else if (cashFlow.userFilters?.Al) {
      setEndDate(cashFlow.userFilters?.Al)
    } else {
      setEndDate(`31/12/${new Date().getFullYear()}`)
    }
    setFilterFirstCharge(false)
  }, [cashFlow.userFilters])

  useEffect(() => {
    if (cashFlow.coins.length || cashFlow.coinsLoading) {
      return;
    }
    dispatch(getCoinsRequest())
  }, [])

  useEffect(() => {
    if (cashFlow.companiesLoading || !endDate) {
      return;
    }
    dispatch(getCompaniesRequest(startDate, endDate))
  }, [startDate, endDate])
  
  // useEffect(() => {
  //   if (!cashFlow?.coins?.length || selectedCoin) {
  //     return;      
  //   }
  //   console.log(cashFlow?.coins[0])
  //   setSelectedCoin(cashFlow?.coins[0].CodMoneda)
  // }, [cashFlow?.coins])


  return (
    <Grid container direction="row">
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Moneda"
          value={selectedCoin}
          onChange={(e) => {
            setSelectedCoin(e.target.value)
            setFilterHasChanged(true)
          }}
          width="4.5em"
        >
          {cashFlow.coins.map(c => (
            <option 
              key={c.CodMonedaInternacional} 
              value={c.CodMonedaInternacional}
            >
              {c.Descripcion}
            </option>
          ))}
        </MaterialSelect>
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <MaterialDateInput
          label="Del"
          value={startDate}
          onChange={(date) => {
            setFilterHasChanged(true)
            setStartDate(date)
          }}
          width="7em"
        />
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <MaterialDateInput
          label="Al"
          value={endDate}
          onChange={(date) => {
            setFilterHasChanged(true)
            setEndDate(date)
          }}
          width="7em"
        />
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Empresa"
          value={selectedCompany}
          onChange={(e) => {
            setFilterHasChanged(true)
            setSelectedCompany(e.target.value)
          }}
          width="5em"
        >
          {!!cashFlow?.companies?.length && <option value="">Todos</option>}
          {cashFlow.companies.map(c => (
            <option 
              key={c.CodEmpresa} 
              value={c.CodEmpresa}
            >
              {c.Descripcion}
            </option>
          ))}
        </MaterialSelect>
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Modo"
          value={mode}
          onChange={(e) => {
            setFilterHasChanged(true)
            setMode(e.target.value)}
          }
          width="6em"
        >
          {Modes.map((p) => (<option key={p.value} value={p.value}>{p.label}</option>))}
        </MaterialSelect>
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <ProjectsSearchInput 
          label={Modes.find(m => m.value === mode).label}
          selectedProject={selectedProject} 
          setSelectedProject={(data) => {
            setFilterHasChanged(true)
            setSelectedProject(data)
          }} 
          width='15em'
        />
      </Grid>
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Escala"
          value={period}
          onChange={(e) => {
            setFilterHasChanged(true)
            setPeriod(e.target.value)
          }}
          width="5em"
        >
          {Periods.map((p) => (<option key={p.value} value={p.value}>{p.label}</option>))}
        </MaterialSelect>
      </Grid>
    </Grid>
  )
}

export default InputsGroup